import { render, staticRenderFns } from "./EnableAddressUpdate.vue?vue&type=template&id=42aaf5f2&scoped=true&"
import script from "./EnableAddressUpdate.vue?vue&type=script&lang=js&"
export * from "./EnableAddressUpdate.vue?vue&type=script&lang=js&"
import style0 from "./EnableAddressUpdate.vue?vue&type=style&index=0&id=42aaf5f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aaf5f2",
  null
  
)

export default component.exports